/**
 * Build a browser URL for uploads. Supports legacy relative paths (/api/uploads/...)
 * and absolute presigned HTTPS URLs returned when STORAGE_BACKEND=s3.
 */
export function resolveAssetUrl(backendBase, pathOrUrl) {
  if (pathOrUrl == null || pathOrUrl === '') return null;
  const s = String(pathOrUrl).trim();
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  const base = (backendBase || '').replace(/\/$/, '');
  return `${base}${s.startsWith('/') ? '' : '/'}${s}`;
}
